import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import { User } from 'iconsax-react';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { ruoloConsiglio } from '../../../../components/Consiglio/ruoli';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";


// Le date arrivano come 'YYYY-MM-DD': si spezzano invece di passare da new Date(),
// che a ovest di Greenwich sposterebbe il giorno.
const formatDate = (valore) => {
	const iso = valore ? String(valore).substring(0, 10) : '';
	const [anno, mese, giorno] = iso.split('-');
	if (!anno || !mese || !giorno) return iso;
	return `${giorno}/${mese}/${anno}`;
};

export const SchedaSocio = () => {
	const navigate = useNavigate();

	const { id } = useParams();

	const [socio, setSocio] = useState(null);
	// Titolo della pagina = nome del socio; finché non è caricato resta quello generico
	usePageTitle(socio?.name || '');
	const [loadingShowed, setLoadingShowed] = useState(false);

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	// Campi modificabili della scheda
	const [membershipRank, setMembershipRank] = useState('MEMBER');
	const [directorRole, setDirectorRole] = useState('COUNCILLOR');
	const [dateStart, setDateStart] = useState('');
	const [dateEnd, setDateEnd] = useState('');
	const [feePaid, setFeePaid] = useState('false');
	const [bookStatus, setBookStatus] = useState('ACTIVE');
	const [bookStatusDate, setBookStatusDate] = useState('');
	const [notes, setNotes] = useState('');

	// Stato nel libro soci nella tendina accanto al titolo: si salva subito (regola SUI).
	// La data dello stato, se non indicata, la mette il server (oggi); si corregge nel riquadro.
	const cambiaStato = async (nuovo) => {
		const auth = getAuth();
		if (!auth) return { annullato: true };
		const risultato = await new MyApiClient().updateMemberBookEntry(auth.token, id, { bookStatus: nuovo });
		if (!risultato || risultato.error) return { error: risultato?.error || 'Errore generico' };
		setBookStatus(risultato.bookStatus || nuovo);
		setBookStatusDate(risultato.bookStatusDate || '');
		if (risultato.dateEnd) setDateEnd(risultato.dateEnd);
		return {};
	};
	useStatoNelTitolo({
		visibile: !!socio,
		stati: [
			{ value: 'ACTIVE', label: 'Attivo', tono: 'attivo' },
			{ value: 'RESIGNED', label: 'Dimesso', tono: 'non-attivo' },
			{ value: 'EXPELLED', label: 'Espulso', tono: 'cancellato' },
		],
		valore: bookStatus,
		onCambia: cambiaStato,
	});

	const getAuth = () => {
		const tokenDetailsString = sessionStorage.getItem('userDetails');
		if (!tokenDetailsString) return null;
		const tokenDetails = JSON.parse(tokenDetailsString);
		return { token: tokenDetails.idToken, clubId: tokenDetails.localId };
	};

	const mostraErrore = (testo) => {
		setModalTitle("Errore durante l'operazione");
		setModalText(testo);
		setModalShowed(true);
	};

	useEffect(() => {
		const carica = async () => {
			const auth = getAuth();
			if (!auth) return;

			const apiClient = new MyApiClient();
			setLoadingShowed(true);
			const risultato = await apiClient.getMemberBookEntry(auth.token, id);
			setLoadingShowed(false);

			if (!risultato || risultato.error) {
				mostraErrore("Non è stato possibile caricare la scheda del socio.");
				return;
			}

			setSocio(risultato);
			setMembershipRank(risultato.membershipRank || 'MEMBER');
			setDirectorRole(risultato.directorRole || 'COUNCILLOR');
			setDateStart(risultato.dateStart || '');
			setDateEnd(risultato.dateEnd || '');
			setFeePaid(risultato.paymentStatus === 'PAID' ? 'true' : 'false');
			setBookStatus(risultato.bookStatus || 'ACTIVE');
			setBookStatusDate(risultato.bookStatusDate || '');
			setNotes(risultato.notes || '');
		};

		carica();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const salva = async () => {
		if (!dateStart) {
			mostraErrore("La data di entrata deve essere valorizzata per continuare");
			return;
		}
		if (bookStatus !== 'ACTIVE' && !bookStatusDate) {
			mostraErrore("Indicando lo stato Dimesso o Espulso è necessario specificare la data corrispondente");
			return;
		}

		const auth = getAuth();
		if (!auth) return;

		const body = {
			dateStart: dateStart,
			bookStatus: bookStatus,
			notes: notes
		};
		if (dateEnd) body.dateEnd = dateEnd;
		if (bookStatusDate) body.bookStatusDate = bookStatusDate;
		// La quota si imposta a mano solo per i soci inseriti manualmente: per
		// quelli nati da un ordine lo stato deriva dall'ordine stesso.
		if (socio && socio.source !== 'ORDER') body.feePaid = (feePaid === 'true');

		const apiClient = new MyApiClient();
		setLoadingShowed(true);
		const risultato = await apiClient.updateMemberBookEntry(auth.token, id, body);
		setLoadingShowed(false);

		if (!risultato || risultato.error) {
			mostraErrore("Si è verificato un errore durante il salvataggio: " + (risultato ? risultato.error : 'errore generico'));
			return;
		}

		navigate('/struttura/soci/list');
	};

	const quotaDaOrdine = socio && socio.source === 'ORDER';

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
					<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => setModalShowed(false)} variant="" className="btn-close"></Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>Chiudi</Button>
				</Modal.Footer>
			</Modal>

			<div style={{ maxWidth: '760px' }}>
				<div className="card">
					<div className="card-header d-flex justify-content-between align-items-center">
						<h4 className="card-title mb-0">Dati socio</h4>
						{socio && (
							<Button
								className="btn btn-light btn-add"
								onClick={() => { navigate('/struttura/clienti/player_profile/' + socio.userId); }}
							>
								<User size="18" className="me-1" /> Visualizza player
							</Button>
						)}
					</div>
					<div className="card-body">
						<Row>
							<Col md={6} className="mb-3">
								<label className="form-label">N. progressivo</label>
								<div className="form-control-plaintext">
									{socio && socio.memberNumber ? String(socio.memberNumber).padStart(3, '0') : '—'}
								</div>
							</Col>
							<Col md={6} className="mb-3">
								<label className="form-label">Player</label>
								<div className="form-control-plaintext">{socio ? socio.name : ''}</div>
							</Col>
							{socio && socio.decidedByAssembly && (
								<Col md={6} className="mb-3">
									<label className="form-label">Ammesso con delibera</label>
									{/* Il collegamento al verbale che ha deciso l'ammissione: senza,
									    la prova andrebbe cercata a mano fra le assemblee. Numero e
									    data sono quelli fotografati al momento della decisione. */}
									<div className="form-control-plaintext">
										<a href={'/struttura/assemblee/' + socio.decidedByAssembly.id}>
											{`Assemblea n. ${socio.decidedByAssembly.number}`}
											{socio.decidedByAssembly.date ? ` del ${formatDate(socio.decidedByAssembly.date)}` : ''}
										</a>
									</div>
								</Col>
							)}
							<Col md={6} className="mb-3">
								<label className="form-label">Livello</label>
								<div className="form-control-plaintext">
									{socio && socio.level === 'JUNIOR' ? 'Junior' : 'Senior'}
								</div>
							</Col>
							<Col md={6} className="mb-3">
								<label className="form-label">Tipologia</label>
								{/* Derivata, non modificabile: la nomina nel consiglio direttivo
								    avviene dalla sua pagina, che raccoglie anche mandato e firma.
								    Cambiarla da qui creava membri senza mandato. */}
								<div className="form-control-plaintext">
									{membershipRank === 'DIRECTOR'
										? `Consiglio direttivo${ruoloConsiglio(directorRole).label ? ' · ' + ruoloConsiglio(directorRole).label : ''}`
										: 'Socio'}
								</div>
								<div className="sid-firma-hint">
									La composizione del consiglio direttivo si gestisce dalla{' '}
									<a href="/struttura/cda/list" style={{ color: '#E66A0F', fontWeight: 600 }}>sua pagina</a>.
								</div>
							</Col>
							<Col md={6} className="mb-3">
								<label className="form-label">Data in entrata</label>
								<Form.Control type="date" value={dateStart} onChange={(e) => setDateStart(e.target.value)} />
							</Col>
							<Col md={6} className="mb-3">
								<label className="form-label">Data uscita</label>
								<Form.Control type="date" value={dateEnd} onChange={(e) => setDateEnd(e.target.value)} />
							</Col>
						</Row>
					</div>
				</div>

				<div className="card">
					<div className="card-header"><h4 className="card-title mb-0">Stato pagamento</h4></div>
					<div className="card-body">
						<label className="form-label">Quota associativa</label>
						<Form.Select value={feePaid} onChange={(e) => setFeePaid(e.target.value)} disabled={quotaDaOrdine}>
							<option value="true">Pagato</option>
							<option value="false">Non pagato</option>
						</Form.Select>
						<small className="text-muted">
							{quotaDaOrdine
								? "Questo socio deriva da un acquisto: lo stato del pagamento segue l'ordine collegato e non è modificabile qui."
								: "Pagato = richiesta e pagamento ok · Non pagato = richiesta ok ma quota non pagata o scaduta."}
						</small>
					</div>
				</div>

				<div className="card">
					<div className="card-header"><h4 className="card-title mb-0">Stato nel libro soci</h4></div>
					<div className="card-body">
						<Row>
							<Col md={6} className="mb-3">
								<label className="form-label">Data stato</label>
								<Form.Control type="date" value={bookStatusDate} onChange={(e) => setBookStatusDate(e.target.value)} />
							</Col>
						</Row>
						<small className="text-muted">
							Lo stato (Attivo, Dimesso, Espulso) si sceglie dalla tendina accanto al nome e si salva subito, con la data di oggi: qui puoi correggere la data.
						</small>
					</div>
				</div>

				<div className="card">
					<div className="card-header"><h4 className="card-title mb-0">Note</h4></div>
					<div className="card-body">
						<Form.Control
							as="textarea"
							rows={4}
							value={notes}
							onChange={(e) => setNotes(e.target.value)}
							placeholder="Aggiungi note libere sul socio…"
						/>
					</div>
				</div>

				{/* «Elimina socio» (che lo metteva Dimesso) è tolto: lo stato si cambia dalla tendina accanto al titolo */}
				<div className="d-flex justify-content-end mb-4">
					<div className="d-flex gap-2">
						{/* «Vendi la quota associativa»: era un'icona sulla riga della lista, ora sta qui (03/10/2026) */}
						{socio && !socio.orderId && !socio.dateStart && (
							<Button
								className="btn btn-add sid-btn-secondary"
								onClick={() => {
									const parametri = new URLSearchParams({ newCustomerId: socio.userId, newCustomerName: socio.name || 'Cliente' });
									navigate('/struttura/booking/userSubscriptions/new?' + parametri.toString());
								}}
							>
								Vendi quota
							</Button>
						)}
						<Button className="btn btn-add sid-btn-secondary" onClick={() => { navigate('/struttura/soci/list'); }}>
							Annulla
						</Button>
						<Button className="btn btn-primary btn-add" style={{ textTransform: 'none' }} onClick={salva}>Salva modifiche</Button>
					</div>
				</div>
			</div>
		</>
	)
}

export default SchedaSocio;
